import { API_REO_CONTACT, API_REO_CONTACT_BY_ID, API_REO_DATA, API_REO_HISTORY, API_REO_RENTAL_LEDGER } from 'config'
import Api from 'services/api'

export const getRentalLedgers = () => {
  return Api.get(API_REO_RENTAL_LEDGER)
}
export const updateRentalLedger = (data: Record<string, any>) => {
  return Api.put(API_REO_RENTAL_LEDGER, data)
}

export const getRealEstateOwned = (key: string) => {
  return Api.get(API_REO_DATA, { key })
}
export const updateRealEstateOwned = (key: string, data: Record<string, any>) => {
  return Api.put(API_REO_DATA, { key, data })
}

export const getRealEstateOwnedLogs = (key: string, field: string) => {
  return Api.get(API_REO_HISTORY, { key, field })
}

export const getReoContacts = () => {
  return Api.get(API_REO_CONTACT)
}

export const addNewReoContact = (data: Record<string, any>) => {
  return Api.post(API_REO_CONTACT, data)
}

export const updateReoContact = (id: number, data: Record<string, any>) => {
  return Api.put(API_REO_CONTACT_BY_ID, data, { id })
}

export const deleteReoContact = (id: number) => {
  return Api.delete(API_REO_CONTACT_BY_ID, {}, { id })
}
